import React, { useContext, useEffect, useState } from 'react'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { Outlet, useParams } from 'react-router'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import SongwriterSubNavigation from '@Components/Navigations/SongwriterSubNavigation'

import { PARAM } from '@App/navigation/param'

const SongwriterLayout = () => {
    const { songwriterStore, uiStore } = useContext(StoresContext)
    const [loading, setLoading] = useState<boolean>(false)
    const { songwriterId } = useParams<typeof PARAM>()

    useEffect(() => {
        loadSongwriter().then()
    }, [songwriterId])

    useEffect(
        () => () => {
            songwriterStore.destroySongwriter()
        },
        []
    )

    const loadSongwriter = async () => {
        setLoading(true)
        await songwriterStore.setCurrentSongwriterId(songwriterId)
        setLoading(false)
    }

    return songwriterStore.optionalCurrentSongwriterId ? (
        <>
            <title>Member</title>
            <main className="rightsholder-scene">
                {loading ? (
                    <PointPreloader />
                ) : (
                    <>
                        {!uiStore.isMobile && <SongwriterSubNavigation />}
                        <div className="rightsholder-switch-container">
                            <div className="global-container">
                                <Outlet />
                            </div>
                        </div>
                    </>
                )}
            </main>
        </>
    ) : (
        <></>
    )
}

export default observer(SongwriterLayout)
